import React from "react";
import { Container } from "react-bootstrap";
import HeroSection from "./HeroSection";
import Marquee from "./Marquee";
import Questions from "./Questions";
import TopCoins from "./TopCoins";
import TopCommodities from "./TopCommodities";
import WalletGrid from "./WalletGrid";
import Services from "./Services";
import Testimonials from "./Testimonials";

const Home = () => {
  return (
    <div className="home-section position-relative overflow-hidden">
      <Container fluid className="hero-container position-relative z-1 ">
        <div style={{ maxHeight: "100vh" }}>
          <HeroSection />
        </div>
      </Container>
      <Marquee />
      <WalletGrid />
      <TopCoins />
      <TopCommodities />
      <Services />
      <Testimonials />
      <Questions />
    </div>
  );
};

export default Home;
